import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Fade from 'react-reveal/Fade';

const useStyles = makeStyles(theme => ({
    rowContainer: {
        paddingLeft: "5em",
        paddingRight: "5em",
        overflowX: "hidden",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "1.5em",
            paddingRight: "1.5em",
        }
    },
    itemContainer: {
        maxWidth: "40em"
    }
}))

export default function ThreeInRow(props) {

    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const content = props.content;

    const image = props.image;

    let imageW = 300;

    if (props.imageW) {
        imageW = props.imageW;
    }


    const subtitleTxt1 = () => {
        let x = content.subtitle1;
        const lines = x.split("\n");
        return (
            <div>
                {lines.map((line, index) => (
                    <Typography variant="subtitle1" className={classes.subtitle} style={{ textAlign: "justify", maxWidth: image ? "650px" : null, lineHeight: 1.5, marginBottom: "0.4em" }}
                        key={index} >
                        {line}
                    </Typography>))}
            </div>
        )
    }

    const subtitleTxt2 = () => {
        let x = content.subtitle2;
        const lines = x.split("\n");
        return (
            <div>
                {lines.map((line, index) => (
                    <Typography variant="subtitle1" className={classes.subtitle} style={{ textAlign: "justify", maxWidth: image ? "650px" : null, lineHeight: 1.5, marginBottom: "0.4em" }}
                        key={index} >
                        {line}
                    </Typography>))}
            </div>
        )
    }

    return (
        <Grid container direction="row" justify="center" alignItems="center" className={classes.rowContainer} style={{ marginTop: "5em", marginBottom: "5em" }}>


            <Grid item container direction="column" md style={{ maxWidth: "40em" }}>
                <Grid item>
                    <Fade duration={1500} distance={matchesSM ? "0" : null} right >
                        <Typography variant="h4" align={matchesSM ? "center" : undefined} paragraph>{content.title1}</Typography>
                        <div >
                            {subtitleTxt1()}
                        </div>
                    </Fade>
                </Grid>

            </Grid>

            {image ? <Grid item container direction="column" md alignItems="center" style={{ maxWidth: "40em", marginTop: matchesSM ? "0em" : 0, marginBottom: matchesSM ? "0em" : 0, }}>
                <Grid item>
                    <Fade duration={1500} >
                        <img alt="service" src={image} style={{ width: imageW, maxWidth: "100%" }} />
                    </Fade>
                </Grid>
            </Grid> : null}


            <Grid item container direction="column" md style={{ maxWidth: "40em" }}>
                <Grid item>
                    <Fade duration={1500} distance={matchesSM ? "0" : null} left >
                        <Typography variant="h4" align={matchesSM ? "center" : undefined} paragraph>{content.title2}</Typography>
                        <div >
                            {subtitleTxt2()}
                        </div>
                    </Fade>
                </Grid>
            </Grid>


        </Grid>
    )
}
